export default "__VITE_ASSET__DfjnC5io__"